import { MRT_Row } from '@talentmesh/table';
import { toast } from 'sonner';
import { useUpdateShortlistedProfilesStatus } from '../../../../api/useShortlistedProfiles';
import ShortlistedStatusAction from '../../components/ShortlistedStatusAction';
import { useOutreachCandidatePopoutContext } from '../../Outreach/OutreachContext';
import { useShortlistedListContext } from '../ShortlistedListContext';
import { ShortlistedProfile, ShortlistedStatus } from '@/Pages/Candidates/AiSearch/api/DTO/ShortlistedProfile';
import { useLinkedInMessageOutreach } from '@/Pages/Candidates/AiSearch/api/useOutreachCandidate';
import htmlToPlainText from '@/Pages/Candidates/AiSearch/utils/htmlToPlainText';
import UIStrings from '@/Utils/UIStrings';

interface StatusCellProps {
    row: MRT_Row<ShortlistedProfile>;
}

const StatusCell = ({ row }: StatusCellProps) => {
    const { status: profileStatus, id } = row.original;
    const { mutate: mutateShortlistedProfiles } = useShortlistedListContext();
    const { trigger: triggerStatusChange } = useUpdateShortlistedProfilesStatus();
    const { openLinkedInMessagePopout } = useOutreachCandidatePopoutContext();
    const { data: linkedInMessage } = useLinkedInMessageOutreach();

    const handleOnClickMenuItem = async (newStatus: ShortlistedStatus) => {
        if (newStatus === 'ContactTaskInMail') {
            if (!linkedInMessage) {
                openLinkedInMessagePopout([{ ...row.original.profile, id }]);
                return;
            }

            const plainText = htmlToPlainText(linkedInMessage.message || '');

            const clipboardItem = new ClipboardItem({
                'text/html': new Blob([linkedInMessage.message], { type: 'text/html' }),
                'text/plain': new Blob([plainText], { type: 'text/plain' }),
            });

            navigator.clipboard.write([clipboardItem]);
        }

        await triggerStatusChange({ shortlistedProfilesIds: [id], shortlistedStatus: newStatus });

        toast.success(UIStrings.NumberOfCandidateStatus(1, UIStrings[newStatus]));
        mutateShortlistedProfiles();
    };

    return <ShortlistedStatusAction onChangeCallback={handleOnClickMenuItem} profileStatus={profileStatus} />;
};

export default StatusCell;
